import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'components/common/PageHeader';
import { useEffect, useState } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { sendCode } from 'redux/mlSlice';
import { useQuery } from 'utils/useQuery';

const CallbackML = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [error, setError] = useState(false);

  const query = useQuery();
  const mlCode = query.get('code');
  //console.log(mlCode);
  useEffect(async () => {
    if (mlCode) {
      const response = await dispatch(sendCode(mlCode));

      if (response.status === 200) {
        navigate('/ml');
      } else {
        setError(response);
      }
    }
  }, [mlCode]);

  return (
    <>
      <PageHeader
        title="Mercado Libre"
        description="Por favor espere mientras procesamos la información."
        className="mb-3 bg-white"
      />

      {error || !mlCode ? (
        <Card bg="white" className="text-center">
          <Card.Header>
            <Card.Title className="text-danger">
              <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />{' '}
              Error
            </Card.Title>
          </Card.Header>
          <Card.Body className="pt-0">
            <Card.Text>
              {error || (
                <span>
                  Hubo un error al procesar la información.
                  <br />
                  Por favor, vuelva a intentar iniciar sesión en Mercado Libre
                  desde{' '}
                  <Link to="/ml" className="text-primary">
                    este enlace
                  </Link>
                  .
                  <br />
                  <br />
                  Si el problema persiste, por favor, contacte con el equipo de
                  soporte.
                </span>
              )}
            </Card.Text>
          </Card.Body>
        </Card>
      ) : (
        <Card bg="white">
          <Card.Header className="d-flex flex-column align-items-center justify-content-center">
            <Card.Title className="mb-4">Cargando</Card.Title>
            <Spinner
              animation="border"
              variant="primary"
              role="status"
              className="mb-4"
            />
            <Card.Subtitle className="mb-2">
              Estamos procesando la informacion...
            </Card.Subtitle>
            <Card.Subtitle>No cierre esta ventana.</Card.Subtitle>
          </Card.Header>
        </Card>
      )}
    </>
  );
};

export default CallbackML;
